"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const base_url_1 = require("./base-url");
const header_1 = require("./helpers/header");
const nested_error_1 = require("./helpers/nested-error");
async function findCanonicalUsers(query, accessToken, correlationId, includeClients) {
    try {
        if (query.length === 0) {
            return [];
        }
        const data = (await axios_1.default.request({
            method: 'GET',
            url: `${base_url_1.getBaseUrl()}/search/canonicalPrincipals/bySubstring`,
            headers: header_1.getAuthAndCorrelationHeaders(accessToken, correlationId),
            params: {
                q: query,
                canonicalize: true,
                skipCache: Math.random(),
            },
        })).data;
        return data.canonical_principals.filter((principal) => (includeClients || !principal.is_client) && !principal.is_pending);
    }
    catch (err) {
        throw nested_error_1.nestError(`Searching for canonical users failed`, err.error);
    }
}
exports.findCanonicalUsers = findCanonicalUsers;
//# sourceMappingURL=coam-users.js.map